import { useTranslation } from 'react-i18next';

import { ProjectStatus } from '@/features/projects/shared/types/project-status';
import {
  StatusIndicator,
  StatusIndicatorType,
} from '@/shared/components/status-indicator';

export const ProjectStatusIndicator = ({
  status = ProjectStatus.ACTIVE,
}: {
  status?: ProjectStatus;
}) => {
  const { t } = useTranslation('shared');

  return (
    <StatusIndicator
      text={t(status as any)}
      type={
        status === ProjectStatus.ACTIVE
          ? StatusIndicatorType.POSITIVE
          : StatusIndicatorType.NEGATIVE
      }
    />
  );
};
